/** The rules of a repository source's paths (polish round one, 2026-10-16: the whole repository; the list, the row's line and the defaults
 *  stay in `knowledge.ts`). "/" or "*" alone means the whole repository and is stored as `["/"]`; a list holding either collapses to it.
 *  Patterns beyond that are refused with a plain hint (DECISIONS 2026-10-16, polish round one). Pure: the schema, the reader and the dialogs
 *  share it. */
/** the one stored form of "the whole repository" */
export const REPO_WHOLE = "/";
/** the row line's words for it, after the repository's address */
export const REPO_WHOLE_WORDS = "whole repository";
/** the refusal a pattern gets, in the dialog and from the API (at most 30 words) */
export const REPO_PATTERN_HINT = "Patterns are not read: a folder ends with /, a file is its path.";
const PATTERN = /[*?[\]{}]/;

/** "/" or "*" alone (after trimming): the whole repository */
export const meansWholeRepository = (path: string): boolean => path.trim() === "/" || path.trim() === "*";
/** a stored list that reads everything */
export const isWholeRepository = (paths: readonly string[]): boolean => paths.some(meansWholeRepository);
/** a list as it is stored: `["/"]` when it holds "/" or "*" anywhere, else the list itself */
export const collapseRepositoryPaths = (paths: readonly string[]): string[] => (isWholeRepository(paths) ? [REPO_WHOLE] : [...paths]);

/** Why a path cannot be read, or null: relative to the repository (no leading slash, no `..` segment, no backslash, no control character),
 *  and no pattern. "/" and "*" alone are the whole repository. A folder ends in `/`. */
export function repositoryPathProblem(raw: string): string | null {
  const p = raw.trim();
  if (meansWholeRepository(p)) return null;
  if (PATTERN.test(p)) return REPO_PATTERN_HINT;
  if (p.startsWith("/") || /\\/.test(p) || /[\u0000-\u001f]/.test(p) || p.split("/").some((seg) => seg === "..")) return "a path relative to the repository";
  return null;
}
